import { ILimits } from '@@/common/ts';

export const SIMPLE_MIXING_DEFAULT_BAG_INFO = {
  weight: 0,
  price: 0,
};

export const SIMPLE_MIXING_BAG_INFO_LIMITS = {
  weight: { min: 1, max: 10e3 } as Required<ILimits>,
  price: { min: 0, max: 10e4 } as Required<ILimits>,
};
